import React, { useState } from "react";
import logo from "../../../assets/images/1024_1024.png";
import ReceiptTable from "./components/table";
import LetterTemplates from "./letterTemplate";

const ReceiptTemplates = () => {
  const [selectedCard, setSelectedCard] = useState("1");

  const handleSelect = (value) => {
    setSelectedCard(value); // Set the selected card's value
  };

  return (
    <div className={"flex flex-col gap-2"}>
      <div className="flex flex-row gap-2">
        <CardType1
          isSelected={selectedCard === "1"}
          onChange={() => handleSelect("1")}
        />
      </div>
      {/* <div className="flex flex-row gap-2">
        <CardType2
          isSelected={selectedCard === "2"}
          onChange={() => handleSelect("2")}
        />
      </div> */}
    </div>
  );
};

const CardType1 = ({ isSelected, onChange }) => {
  return (
    <div
      onClick={onChange}
      className={`flex flex-row gap-2 items-center justify-between text-theme w-full `}
    >
      <div
        className={`flex-1 flex flex-col gap-20 rounded-md border p-4 ${
          isSelected ? "border border-primary-800 rounded-md" : ""
        }`}
      >
        <div className={`flex-1 flex flex-col gap-4`}>
        <LetterTemplates showAllCards={false} defaultSelected="2" />
          <div className="flex flex-row justify-between items-center">
            <div>
              <p className="text-textLight">From</p>
              <span className="font-medium">
                <p>Synswift</p>
                <p className="w-72">
                  C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit
                  Singh Nagar, Punjab 140308
                </p>
              </span>
            </div>
            <div className="text-left">
              <p className="text-textLight">To</p>
              <span className="font-medium">
                <p>Synswift</p>
                <p className="w-72">
                  C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit
                  Singh Nagar, Punjab 140308
                </p>
              </span>
            </div>
          </div>
          <ReceiptTable />
        </div>
        <div className="border-t text-center py-2 text-textLight">
          <p>This is a computer generated receipt, No signature required</p>
        </div>
      </div>
    </div>
  );
};

const CardType2 = ({ isSelected, onChange }) => {
  return (
    <div
      onClick={onChange}
      className={`flex flex-row gap-2 items-center justify-between text-theme w-full `}
    >
      <div
        className={`flex-1 flex flex-col gap-20 rounded-md border p-4 ${
          isSelected ? "border border-primary-800 rounded-md" : ""
        }`}
      >
        <div className={`flex-1 flex flex-col gap-4`}>
        <LetterTemplates showAllCards={false} defaultSelected="3" />
          <div className="flex flex-row justify-between items-center">
            <div>
              <p className="text-textLight">From</p>
              <span className="font-medium">
                <p>Synswift</p>
                <p className="w-72">
                  C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit
                  Singh Nagar, Punjab 140308
                </p>
              </span>
            </div>
            <div className="text-left">
              <p className="text-textLight">To</p>
              <span className="font-medium">
                <p>Synswift</p>
                <p className="w-72">
                  C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit
                  Singh Nagar, Punjab 140308
                </p>
              </span>
            </div>
          </div>
          <ReceiptTable />
        </div>
        <div className="border-t text-center py-2 text-textLight">
          <p>This is a computer generated receipt, No signature required</p>
        </div>
      </div>
    </div>
  );
};

export default ReceiptTemplates;
